import $http from "../../axios";
import { Notification } from 'element-ui';
import moment from "moment";

export async function fetchReportLogs({commit, state}) {
    state.loading = true;
    await $http.get('/api/get-report-logs', {params:state.params})
    .then((response) => {
        commit('setReportData', response.data.data)
        state.loading = false;
    })
    .catch((error) => {
        state.loading = false;
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 1500,
            customClass: 'notification-box',
        });
    })
}

export async function fetchTypesIntegration ({commit, state}) {
    await $http.get('/api/get-types-integration', {params:state.params})
        .then((response) => {
            commit('setTypesIntegration', response.data.data)
            state.loading = false;
        })
        .catch((error) => {
            state.loading = false;
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        });
}

export async function fetchTypesInformationIntegration ({commit, state}) {
    await $http.get('/api/get-types-information-integration', {params:state.params})
        .then((response) => {
            commit('setTypesInformationIntegration', response.data.data)
            state.loading = false;
        })
        .catch((error) => {
            state.loading = false;
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        });
}

export async function downloadLogIntegration ({commit, state}, logIntegration) {
    const params = {
        log_integration_id: logIntegration,
        date_generate: moment(new Date()).format("YYYY/MM/DD HH:mm:ss")
    }

    await $http({
        url: '/api/download-report-logs',
        method: 'GET',
        params: params,
        responseType: 'blob',
    }).then((response) => {
        console.log(response);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Informe-Logs-Integraciones.xlsx');
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });
    })
}


// WEBPACK FOOTER //
// ./src/modules/report-log/actions.js